import axios from "axios";
import config from '../../config'
// const BASE_URL = "http://3.22.188.65:8080"
const BASE_URL = config.apiUrl


const GetlisteQuiz = async () =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.get("/rabat-zoo/quiz/api/all" ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
}

const AddQuiz = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.post("/rabat-zoo/quiz/api/add",DataPost ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const updateQuiz = async (DataPost) =>{

    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.put("/rabat-zoo/quiz/api/update",DataPost ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const disableQuiz = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/quiz/api/disable/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const removeQuiz = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/quiz/api/remove/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const enableQuiz = async (id) =>{
    const options = {
        baseURL: BASE_URL,
        responseType: 'json',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            'Access-Control-Allow-Origin':"*/*",
            // 'Authorization': `Bearer ${Token}`
        },
    }
  
    const instance = axios.create(options)
    
      try {
        const response = await instance.get("/rabat-zoo/quiz/api/enable/" + id ); 
        return response;
      } catch (error) { 
          throw error.response 
      }
}

const UploadFileQuiz = async (formData) =>{

    const options = {
        baseURL: BASE_URL,
        headers: {
            'Content-Type': 'multipart/form-data',
          },
    }
  
    const instance = axios.create(options)
      try {
        const response = await instance.post("/rabat-zoo/quiz/api/upload",formData ); 
        return response.data;
      } catch (error) { 
          throw error.response 
      }
  }




export {GetlisteQuiz,AddQuiz,UploadFileQuiz,updateQuiz, disableQuiz, enableQuiz,removeQuiz}
